import { useGobblerMetadataFromPublicNftEndpoint } from 'hooks/gobblers/useGobblerMetadata'
import Link from 'next/link'
import styled from 'styled-components'
import { calculateGooProductionRate } from 'utils/emissions'
import { getCleanGobblerName } from 'utils/gobbler'
import { getCleanNumber } from './GooEquation'

const GobblerTableContainer = styled.table`
  width: calc(100% - 32px);
  max-width: 1126px;
  margin-top: 48px;
  border-collapse: separate;
  border-spacing: 0 12px;

  font-family: 'Matter';
  color: white;

  tbody::before {
    content: '';
    display: block;
    height: 12px;
  }
`

const TableHead = styled.thead`
  background: rgba(0, 0, 0, 0.32);
  font-weight: 600;
  font-size: 16px;
  text-align: left;

  th {
    padding: 28px 0;
  }
  th:nth-child(1) {
    /* text-align: center; */
    padding-left: 64px;
    border-top-left-radius: 32px;
    border-bottom-left-radius: 32px;
  }
  th:nth-last-child(1) {
    border-top-right-radius: 32px;
    border-bottom-right-radius: 32px;
  }
`

const TableBody = styled.tbody`
  tbody::before {
    content: '';
    display: block;
    height: 24px;
  }
`

// Gobbler Row

const GobblerRowContainer = styled.tr`
  background-image: url('/images/factory/gobbler_row.png');
  background-size: 100% 100%;
  width: 100%;
  background-position: center;
  font-weight: 500;

  td {
    font-size: 24px;
  }
`

const GobblerNameCell = styled.td``

const GobbleNameCellLink = styled.a`
  display: flex;
  flex-direction: row;
  margin-left: 64px;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0;
  text-decoration: none;
`

const GobblerImage = styled.img`
  border-radius: 24px;
  height: 82px;
  min-height: 82px;
  min-width: 82px;
  width: 82px;
  margin-right: 20px;
`

const GobblerName = styled.div`
  font-weight: 700;
  line-height: 1.35;
  font-size: 24px;
`

function GobblerRow({
  gobblerId,
  virtualGooBalanceForUser,
}: {
  gobblerId: string
  virtualGooBalanceForUser: number | undefined
}) {
  const gobblerMetadata = useGobblerMetadataFromPublicNftEndpoint(gobblerId)

  const productionRate = calculateGooProductionRate(
    virtualGooBalanceForUser ?? 0,
    gobblerMetadata.multiplier ?? 0,
  )
  const formattedProductionRate = getCleanNumber(productionRate)

  console.log('gobblerMetadata', gobblerMetadata)

  const isRevealed = !!gobblerMetadata.revealed

  return (
    <GobblerRowContainer>
      <GobblerNameCell>
        <Link
          href={{
            pathname: '/gobbler/[gobblerId]',
            query: {
              gobblerId: gobblerId,
            },
          }}
          passHref={true}
        >
          <GobbleNameCellLink>
            <GobblerImage alt="Gobbler" src={gobblerMetadata.image} />
            <GobblerName>
              {isRevealed ? getCleanGobblerName(gobblerMetadata.name) : 'Unrevealed Gobbler'}
            </GobblerName>
          </GobbleNameCellLink>
        </Link>
      </GobblerNameCell>

      {/* <td>{totalGooCreated}</td> */}
      {/* <td>{gooStaked}</td> */}
      {/* <td>{gobblerId}</td> */}

      <td>{isRevealed ? `${gobblerMetadata.multiplier}x` : '??'}</td>
      <td>{isRevealed ? formattedProductionRate : '??'} G/d</td>
    </GobblerRowContainer>
  )
}

export interface GobblerTableProps {
  gobblerIdsOwned: Array<number> | undefined
  virtualGooBalanceForUser: number | undefined
}

const GobblerTable: React.FC<GobblerTableProps> = (props) => {
  const gobblerIds = props.gobblerIdsOwned ?? []
  return (
    <GobblerTableContainer>
      <TableHead>
        <th>Name</th>
        {/* <th>Total Goo Created</th> */}
        {/* <th>Id</th> */}
        {/* <th>Goo Staked</th> */}
        <th>Multiplier</th>
        <th>Daily production</th>
      </TableHead>
      <TableBody>
        {gobblerIds.map((gId) => {
          return (
            <GobblerRow
              key={gId}
              virtualGooBalanceForUser={props.virtualGooBalanceForUser}
              gobblerId={gId.toString()}
            />
          )
        })}
      </TableBody>
    </GobblerTableContainer>
  )
}
export default GobblerTable
export { GobblerTable }
